import Vue from 'vue';

export default {
    state:{
      datatable:{
        tabla_global:null,
        actualizando:false
      }
    },
    mutations: {
      setActualizando(state,status){
        state.datatable.actualizando=status;
      },
      definir_tabla(state,tabla){
        state.datatable.tabla_global = tabla;
      }
    },
    actions: {
      Actualizando_Tabla({commit,state}){
        commit('setActualizando',true);
      },
      Ejecutar_Tabla(context, data) {
        var jquery_table = data.tabla;

        var inicio = data.inicio;

        var table = jquery_table.DataTable({

         responsive: false,
          "bSortCellsTop": true,
          dom: 'Blfrtip',
          buttons: [
            'excel'
          ],
          language: {
              "paginate": {
                  "first": "Primero",
                  "last": "Último",
                  "next": !!data.titles ? data.titles.siguiente : 'Siguiente',
                  "previous": !!data.titles ? data.titles.anterior : 'Anterior',
              },
              "lengthMenu": `${!!data.titles ? data.titles.mostrar : 'Mostrar'} _MENU_ ${!!data.titles ? data.titles.registros : 'registros'} ${!!data.titles ? data.titles.por : 'por'} ${!!data.titles ? data.titles.pagina : 'página'}`,
              "zeroRecords": `No se encontraron resultados`,
              "info": `${!!data.titles ? data.titles.mostrar: 'mostrar'} _START_ ${!!data.titles ? data.titles.a : 'a'} _END_ ${!!data.titles ? data.titles.de : 'de'} _TOTAL_ ${!!data.titles ? data.titles.registros : 'registros'}`,
              "infoEmpty": `${!!data.titles ? data.titles.mostrando : 'mostrando'} 0 a 0 de 0 ${!!data.titles ? data.titles.registros : 'registros'}`,
              "infoFiltered": `(filtrado de _MAX_ ${!!data.titles ? data.titles.registros : 'registros'} totales)`,
              "search": !!data.titles ? data.titles.buscar : 'Buscar:',
              "loadingRecords": "Cargando...",
              "processing": "Procesando..."
          }

        });
        context.commit('definir_tabla',table);

        table.on( 'order.dt search.dt', function () {
            table.column(0, {search:'applied', order:'applied'}).nodes().each( function (cell, i) {
                cell.innerHTML = i+1;
            } );
        }).draw();

        jquery_table.find(".filterhead").each( function ( i,element ) {

          if (i>=inicio) {

            //Si es un input
            if ($(element).hasClass('text_input')) {
              var select = $('<input type="text" class="input_search_table"   placeholder="Buscar" />')
              .appendTo($(this).empty())
              .on( 'keyup change', function () {
                if ( table.column(i).search() !== this.value ) {
                  table .column(i).search( this.value ).draw();
                }
              });
            }
            //Si es una fecha
            else if ($(element).hasClass('date_input')) {
              var select = $('<input type="date" value="" />')
              .appendTo($(this).empty())
              .on( 'change', function () {
                if ( table.column(i).search() !== this.value ) {
                  table .column(i).search( this.value ).draw();
                }
              });
            }
            else{
              var select = $('<select><option value="">Todos</option></select>')
              .appendTo($(this).empty())
              .on( 'change', function () {
                var term = $(this).val();
                table.column( i ).search(term, false, false ).draw();
              });
              table.column( i ).data().unique().sort().each( function ( d, j ) {
                var a = d.replace("<span>","");
                var b = a.replace('</span>',"");
                select.append( '<option value="'+d+'">'+b+'</option>' )
              });
            }
          }
        });



       //Al filtrarse por alguna filtro, ya sea input, sleect o fecha
        table.on('draw', function () {
          if (context.rootState.menu.menu.actualizando==true) {
            jquery_table.find(".filterhead").each( function ( i ) {
              if (i>=inicio) {
                if ($(element).hasClass('text_input')) {
                  var select = $('<input type="text" class="input_search_table"  placeholder="Buscar" />')
                  .appendTo($(this).empty())
                  .on( 'keyup change', function () {
                    if ( table.column(i).search() !== this.value ) {
                      table .column(i).search( this.value ).draw();
                    }
                  });
                }
                else{
                  var select = $('<select><option value="">Todos</option></select>')
                  .appendTo($(this).empty())
                  .on( 'change', function () {
                    var term = $(this).val();
                    table.column( i ).search(term, false, false ).draw();
                  });
                  table.column( i ).data().unique().sort().each( function ( d, j ) {
                    var a = d.replace("<span>","");
                    var b = a.replace('</span>',"");
                    select.append( '<option value="'+d+'">'+d+'</option>' )
                  });
                }
              }
            });
            context.commit('setActualizando',false);
          }else{
            jquery_table.find(".filterhead").each( function ( idx,element ) {

                var select = $(element).find('select');
                if ( select.val() === '' ) {
                  select
                    .empty()
                    .append('<option value=""/>');

                  table.column(idx, {search:'applied'}).data().unique().sort().each( function ( d, j ) {
                    select.append( '<option value="'+d+'">'+d+'</option>' );
                  } );
                }

            } );

          }
        });

      },
      Ejecutar_Tabla_ServerSide(context,data){

        var jquery_table  = data.tabla;
        var div_table     = data.tabla+'_table';
        var url           = data.url;
        var inicio        = data.inicio;
        $.fn.dataTable.ext.errMode = 'none';
        $('#'+jquery_table+' thead tr').clone(true).appendTo( '#'+jquery_table+' thead' );
        var table = $('#'+jquery_table).DataTable({
          "processing": true,
          "serverSide": true,
          "scrollY": 500,
          "order": [],
          "scrollX": true,
          "responsive": false,
          "bSortCellsTop": true,
          "dom": 'Blfrtip',
          "buttons": [
            'excel'
          ],
          "ajax": url,
          error: function(error) {
              if (error && error.status == 401) {
                swal({
                  title: "Sesión Caducada",
                  text: "Favor de iniciar sesión de nuevo",
                  icon: "error",
                  button: "Aceptar"
                }).then((value) => {
                  $('#Cerrar_Sesion_LMS').click();
                });
              }
          },
          initComplete: function () {

          },
          drawCallback: function( settings ) {

            table.column(0, {search:'applied', order:'applied'}).nodes().each( function (cell, i) {
              cell.innerHTML = i+1;
            });
            context.dispatch('Filtros_Tabla_ServerSide',data);
          }
        });
        context.commit('definir_tabla',table);
      },
      Filtros_Tabla_ServerSide(context,data){
        //$('#'+div_table).removeClass('width90');
        //$(document).ready(function(){
          var div_table     = data.tabla+'_table';
          var jquery_table  = data.tabla;
          var url           = data.url;
          var inicio        = data.inicio;
          var table         = context.state.datatable.tabla_global;
          $('#'+div_table+' thead tr:eq(1) th').each( function (i,element) {

              if (i>=inicio) {

                if ($(element).hasClass('text_input')) {
                  var title = $(this).text();
                  $(this).html( '<input type="text" placeholder="Buscar" />' );
                  $( 'input', this ).on( 'keyup change', function () {


                    if (this.value.length>4 || this.value.length==0) {


                      if ( table.column(i).search() !== this.value ) {
                          table
                              .column(i)
                              .search( this.value )
                              .draw();
                      }

                    }
                  } );
                }
                else if ($(element).hasClass('date_input')) {
                  var title = $(this).text();
                  $(this).html( '<input type="date" value="" />' );
                  $( 'input', this ).on( 'change', function () {
                      if ( table.column(i).search() !== this.value ) {
                          table
                              .column(i)
                              .search( this.value )
                              .draw();
                      }
                  } );
                }
                else if ($(element).hasClass('select_input')) {

                  var select = $('<select><option value="">Todos</option></select>')
                  .appendTo($(this).empty())
                  .on( 'change', function () {
                    var term = $(this).val();
                    table.column( i ).search(term, false, false ).draw();
                  });
                  table.column( i ).data().unique().sort().each( function ( d, j ) {

                    if (d!=null) {
                      var a = d.replace("<span>","");
                    var b = a.replace('</span>',"");
                    select.append( '<option value="'+d+'">'+b+'</option>' )
                    }


                  });

                }
              }

          });
          $('#'+div_table).addClass('width95');
        //});
      }
    },
    getters: {
      getDatatable(state){
        return state.datatable;
      }
    },

}



// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/src/modules/datatables.js